import { useCallback } from 'react';
import { uniqueId } from 'js/utils/methods.util';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';
import { ITimeout } from '../useGetPlayerTimeout/types';
import { IGNORE_LIMITS_NOTIFICATION } from '../../constants';

export const useSetPlayerTimeout = () => {
    const send = useGenericSend();

    return useCallback(async (
        { startTime, period, emailNotificationType, timeoutId, networkClass }: Types.ISetPlayerTimeoutRequestData
    ) => {
        const { data } = await send<Types.ISetPlayerTimeoutRequestData, { timeout: ITimeout }>({
            ID: 89910,
            responses: [89912, 89900],
            description: 'Set player timeout',
            period,
            correlationId: uniqueId(`${IGNORE_LIMITS_NOTIFICATION}-`),
            ...startTime && { startTime },
            ...timeoutId && { timeoutId },
            ...networkClass && { networkClass },
            ...emailNotificationType && { emailNotificationType }
        });

        return data;
    }, [send]);
};
